import Paginator from './Paginator';
import paginatorStyles from './paginator.module.scss';

export * from './constants';

export { Paginator, paginatorStyles };

export default Paginator;
